var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"h3 mt-3"},[_vm._v("Search for: "+_vm._s(_vm.$route.params.searchquery))]),_c('GameList',{ref:"gameList",attrs:{"gameName":_vm.$route.params.searchquery}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }